<template>
  <div class="new-home">
    <base-head v-if="$route.name !== 'basicAllList'"></base-head>
    <router-view></router-view>
    <!-- <base-footer></base-footer> -->
  </div>
</template>

<script>
import BaseHead from '@/components/v2/BaseHead.vue'
import BaseFooter from '@/components/v2/BaseFooter.vue'
import '../assets/css/common.scss'
import equipmentV2 from '../store/modules/equipmentV2'
import mixins from '@/assets/js/mixins.js'
import { mapActions, mapMutations } from 'vuex'
export default {
  name: 'NewHome',
  mixins: [mixins],
  components: {
    BaseHead,
    BaseFooter
  },
  computed: {},
  async mounted () {
    console.log(this.$route)
    let enterprise = await this.getEnterprise()
    let obj = {}
    if (localStorage.getItem('currentBasic')) {
      obj = JSON.parse(localStorage.getItem('currentBasic'))
    }
    let currentEnterprise = localStorage.getItem('currentEnterprise')
    console.log(enterprise.id, currentEnterprise)
    if (enterprise.id.toString() !== currentEnterprise) {
      localStorage.setItem('currentBasic', '')
      obj = ''
    }
    if (obj) {
      // await this.getEquipmentsData(obj)
      this.setChooseBasic(obj)
    } else {
      if (this.$route.name === 'equipmentControl') {
        this.$Alert.info({
          content: '请先选择基地/塘口',
          duration: 3000,
          status: 'error'
        })
        this.$router.push({
          name: 'basicList'
        })
      }
    }
  },
  methods: {
    ...mapActions(equipmentV2, ['getEquipmentsData', 'getEnterprise']),
    ...mapMutations(equipmentV2, ['setEquipmentsData', 'setChooseBasic'])
  }
}
</script>
<style lang="scss">
.new-home {
  height: 100%;
  color: #fff;
  background: url("../assets/images/bg.png") no-repeat;
  background-size: cover;
  background-position: center 0;
}
</style>
